import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createQuizathonStart,
  editQuizathonStart,
} from "../../redux/quizathon/reducer";
import {
  selectIsCreatingQuizathon,
  selectIsEditingQuizathon,
} from "../../redux/quizathon/selectors";

const useQuizathonEditor = () => {
  const dispatch = useDispatch();
  const isEditingQuizathon = useSelector(selectIsEditingQuizathon);
  const isCreatingQuizathon = useSelector(selectIsCreatingQuizathon);
  const createQuizathon = useCallback(
    (data) => {
      dispatch(createQuizathonStart(data));
    },
    [dispatch]
  );

  const editQuizathon = useCallback(
    (data) => {
      dispatch(editQuizathonStart(data));
    },
    [dispatch]
  );

  return {
    createQuizathon,
    isCreatingQuizathon,
    editQuizathon,
    isEditingQuizathon,
  };
};

export default useQuizathonEditor;
